import axios from 'axios'

const saveTransaction = async function (purchase) {
  console.log('=== saveTransaction iniciou ===')
  console.log('purchase recebido:', purchase)

  const apiUrl = `${process.env.VUE_APP_API_URL}/totem/cadastrarBoleto.php`

  const username = process.env.VUE_APP_IPAG_API_USER
  const password = process.env.VUE_APP_IPAG_API_PASSWORD
  const basicAuth = btoa(`${username}:${password}`)
  const brlCoin = "957"

  // Dígitos a partir de purchase.cartao ("531372******8026")
  let firstDigits = null
  let lastDigits = null
  if (purchase.cartao) {
    const parts = String(purchase.cartao).split('*')
    firstDigits = parts[0] || null
    lastDigits = (parts[parts.length - 1] || '').replace(/\D/g, '') || null
  }

  // ---- Status (aceita tanto status quanto sucesso)
  let statusToSend = ''
  let code = ''
  let reason = ''

  const isApproved = purchase.status === 'approved' || purchase.sucesso === true

  if (isApproved) {
    statusToSend = 'APROVADA'
    code = '00'
    reason = ''
  } else {
    // proteção contra statusReason undefined
    if (purchase.statusReason && typeof purchase.statusReason === 'string') {
      const reasonData = purchase.statusReason.split('-')
      code = reasonData[0] || ''
      reason = reasonData[1] || purchase.statusReason
    } else {
      code = purchase.codigoRetorno || ''
      reason = purchase.motivo || purchase.message || 'Rejeitada'
    }
    statusToSend = 'REJEITADA'
  }

  // ---- Session Storage (com parse correto)
  let installmentSelect = {}
  try {
    installmentSelect = JSON.parse(sessionStorage.getItem('installmentSelect') || '{}')
  } catch (e) {
    console.warn('Erro ao parsear installmentSelect', e)
  }

  const parcelas = installmentSelect.installments
    ? parseInt(installmentSelect.installments, 10)
    : (purchase.installments || purchase.numParcelas || 1)

  let dadosPessoais = {}
  let dadosBoleto = {}
  try {
    dadosPessoais = JSON.parse(sessionStorage.getItem('dadosPessoais') || '{}')
    dadosBoleto = JSON.parse(sessionStorage.getItem('dadosBoleto') || '{}')
  } catch (e) {
    console.warn('Erro ao parsear dadosPessoais/dadosBoleto', e)
  }


  const payloadData = {
    servico: "Boleto Parcelado",
    ec: purchase.cnpj || purchase.id || purchase.ec || purchase.autorizacao || '',
    documento: purchase.cnpj || '',
    clienteTelefone: dadosPessoais.phone || '',
    clienteDocumento: (dadosPessoais.cpf || '').replace(/\D/g, ''),
    situacao: statusToSend,
    codigoRetorno: code,
    refuseReason: reason,
    refuse_reason: reason,
    codigoMCC: purchase.mcc || '',
    autorizacao: purchase.authorizationCode || purchase.autorizacao || '',
    moeda: brlCoin,
    tefNsu: purchase.tefNsu || '',
    nsu: purchase.nsu || '',
    valor: purchase.totalAmount || purchase.valor || 0,
    valorOriginal: dadosBoleto.originalAmount,
    parcelas: parcelas,
    cartaoPortador: purchase.cardHolder || purchase.cartaoPortador || '',
    cartaoPrimeirosDigitos: firstDigits,
    cartaoUltimosDigitos: lastDigits,
    bandeira: purchase.cardBrand || purchase.bandeira || '',
    formaPagamento: purchase.tipoPagamento || purchase.formaPagamento || 'CREDITO',
    formaCaptura: "pinpad",
    origem: 'TOTEM',
    numeroSerie: purchase.serialNumber || '',
    idMovimentacao: purchase.orderNumber || purchase.idMovimentacao || '',

    // Dados do boleto
    idConsulta: dadosBoleto.id || '',
    linhaDigitavel: "",
    codigoBarras: dadosBoleto.barCode || dadosBoleto.codigoBarras || '',
    nome: (dadosBoleto.payer && dadosBoleto.payer.name) || dadosBoleto.nome || '',
    telefone: dadosPessoais.phone || '',
    valorTotal: installmentSelect.totalParcela
      ? parseInt(installmentSelect.totalParcela * 100)
      : (purchase.totalAmount || 0),
    valorJuros: dadosBoleto.interest || dadosBoleto.valorJuros || 0,
    valorMulta: dadosBoleto.fine || dadosBoleto.valorMulta || 0,
    valorDesconto: dadosBoleto.discount || dadosBoleto.valorDesconto || 0,
    vencimento: dadosBoleto.dueDate || dadosBoleto.vencimento || ''
  }

  console.log('API URL:', apiUrl)
  console.log('Payload que será enviado:', payloadData)

  const headers = {
    'Authorization': `Basic ${basicAuth}`,
    'Content-Type': 'application/json'
  }

  try {
    const response = await axios.post(apiUrl, payloadData, { headers })
    console.log('saveTransaction sucesso:', response.data)
    return response
  } catch (error) {
    console.error('Erro no axios.post de saveTransaction:', error.response || error)
    throw error
  }
}

export { saveTransaction }